import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ApiUrl } from "../../constants";
import { prepareHeaders } from "../user/user.api";
import { Kyc, KycEtat } from "./kyc.type";

const KycApi = createApi({
  reducerPath: "kyc",
  baseQuery: fetchBaseQuery({
    baseUrl: `${ApiUrl}/api`,
    prepareHeaders,
  }),
  tagTypes: ["kyc"],
  endpoints: (build) => ({
    // Le dossier de l'utilisateur connecte.
    monKyc: build.query<KycEtat, void>({
      query: () => `/kyc/`,
      providesTags: ["kyc"],
    }),
    // Envoi du dossier : FormData, car il transporte des fichiers. On ne
    // fixe pas Content-Type, le navigateur ajoute la frontiere multipart.
    soumettreKyc: build.mutation<Kyc, FormData>({
      query: (data) => ({ url: `/kyc/`, method: "POST", body: data }),
      invalidatesTags: ["kyc"],
    }),
    // File d'examen, reservee aux admins.
    kycs: build.query<Kyc[], { statut?: string; q?: string }>({
      query: ({ statut, q }) => {
        const params = new URLSearchParams();
        if (statut) params.append("statut", statut);
        if (q) params.append("q", q);
        const qs = params.toString();
        return `/kyc/liste/${qs ? `?${qs}` : ""}`;
      },
      providesTags: ["kyc"],
    }),
    traiterKyc: build.mutation<Kyc, { slug: string; statut: "valide" | "refuse"; motif?: string }>({
      query: ({ slug, ...body }) => ({
        url: `/kyc/${slug}/`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["kyc"],
    }),
  }),
});

export const {
  useMonKycQuery,
  useSoumettreKycMutation,
  useKycsQuery,
  useTraiterKycMutation,
} = KycApi;

export default KycApi;
